import PaginationQueryGet from '@/api/models/PaginationQueryGet'

export interface AssignedCampaignsQuery extends PaginationQueryGet {
	ActivistId: string
	IncludeDeleted?: boolean
}

export interface RawAssignedCampaign {
	id: string
	name: string
	type: string
	status: string
}

export interface AssignedCampaign {
	Id: string
	Name: string
	Type: string
	State: string
}

export const toAssignedCampaign = (raw: RawAssignedCampaign): AssignedCampaign => ({
	Id: raw.id,
	Name: raw.name,
	Type: raw.type,
	State: raw.status
})
